module.exports = __webpack_public_path__ + "media/images/icons/dropdown-3a984b6644b9d9512c4ad83aa67a288c.svg";